import { Modal } from '@app/components/various/Modal';
import { useTranslation } from 'react-i18next';

import { useLookbookListingContext } from '../context/LookbookListingContext';

import { LookbookNavigationSettingsContextProvider } from './LookbookNavigationSettingsContext';
import { LookbookSettingsModalContent } from './LookbookSettingsModalContent';

export const LookbookSettingsModal = () => {
  const { t } = useTranslation(['common', 'settings', 'lookbook']);

  const { selectedLookbookId, isSettingsModalVisible, setIsSettingsModalVisible } = useLookbookListingContext();

  return (
    <>
      <LookbookNavigationSettingsContextProvider lookbookId={selectedLookbookId}>
        <Modal
          title={t('lookbook:navigation.add_pages')}
          description={t('lookbook:settings_description')}
          isOpen={isSettingsModalVisible}
          onClose={() => setIsSettingsModalVisible(false)}
        >
          <LookbookSettingsModalContent />
        </Modal>
      </LookbookNavigationSettingsContextProvider>
    </>
  );
};
